import React from 'react';
import { CalendarCheckIcon } from 'lucide-react';

/**
 * The current Apps Script backend does not expose an availability lookup, so
 * availability is confirmed by the backend when the request is submitted.
 */
export function AvailabilityNotice({
  type
}: {
  type: 'apartment' | 'photoshoot';
}) {
  return <div className="mt-5 flex items-start gap-3 rounded-sm bg-forest-50 px-4 py-3.5 text-[13px] leading-relaxed text-forest-700" data-id="element-27" data-mp="1uyfmrjzv5yq1">
      <CalendarCheckIcon size={16} className="mt-0.5 shrink-0 text-forest-500" aria-hidden="true" data-id="element-28" data-mp="1gxv72wp8wj0r" />
      <p data-id="element-29" data-mp="1lzu8i11fd5v2">
        {type === 'apartment' ? 'Availability is checked by our booking system the moment you send your request. If your dates are taken, you’ll be told straight away — nothing is charged.' : 'Session availability is confirmed by our team after you send your request. You’ll hear back before anything is charged.'}
      </p>
    </div>;
}